export default __webpack_public_path__ + "locales/ru/DeleteProfileEverDialog.json?hash=aa32807e9943ce9f16009e2085293d2c";